import { render, staticRenderFns } from "./stallConfiguration.vue?vue&type=template&id=3c32b34e"
import script from "./stallConfiguration.vue?vue&type=script&lang=js"
export * from "./stallConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports